export enum UserRole {
  teacher = "TEACHER",
  admin = "ADMIN",
  student = "STUDENT",
}
